import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import {
  defaultTableItem,
  TableItem
} from '@/components/organisms/CodeKeyTable'
import { cloneDeep } from 'lodash'

export interface modalCodeKeyParameterInterface {
  isSystemCode: boolean
  defaultCodeKey: string
  onOkClick?: any
  onCancelClick?: any
}

@Module({
  name: 'ModalCodeKeyStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalCodeKeyStore extends BaseStore {
  _isOpen = false

  _isSystemCode = true

  _defaultCodeKey = ''

  _okCallback: any

  _cancelCallback: any

  _selectedItem: TableItem = cloneDeep(defaultTableItem)

  get isOpen(): boolean {
    return this._isOpen
  }

  get isSystemCode(): boolean {
    return this._isSystemCode
  }

  get defaultCodeKey(): string {
    return this._defaultCodeKey
  }

  get parameter(): modalCodeKeyParameterInterface {
    return {
      isSystemCode: this._isSystemCode,
      defaultCodeKey: this._defaultCodeKey
    }
  }

  @Mutation
  public open(params: modalCodeKeyParameterInterface) {
    this._isOpen = true
    this._isSystemCode = params.isSystemCode
    this._defaultCodeKey = params.defaultCodeKey
    this._okCallback = params.onOkClick
    this._cancelCallback = params.onCancelClick
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public ok(selectedItem: TableItem) {
    this._selectedItem = selectedItem

    const result = this._okCallback ? this._okCallback(selectedItem) : true
    if (result === false) return

    this._isOpen = false
  }

  @Mutation
  public cancel() {
    const result = this._cancelCallback ? this._cancelCallback() : true
    if (result === false) {
      return
    }

    this._isOpen = false
  }
}
